import script from "./MatchaWidget.vue?vue&type=script&lang=js"
export * from "./MatchaWidget.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__